import { Currency } from './billing.types';
import { PayerInfo, PayersActionTypes, PayMethodsActionTypes } from './billing.types';

export const GET_PAYERS: PayersActionTypes = 'GET_PAYERS';
export const REGISTER_PAYER: PayersActionTypes = 'REGISTER_PAYER';
export const UPDATE_PAYER: PayersActionTypes = 'UPDATE_PAYER';
export const REVERT_PAYERS_TO_INITIAL_STATE: PayersActionTypes = 'REVERT_TO_INITIAL_STATE';

export const GET_PAYMETHODS: PayMethodsActionTypes = 'GET_PAYMETHODS';
export const REGISTER_PAYMETHODS: PayMethodsActionTypes = 'REGISTER_PAYMETHODS';
export const REMOVE_PAYMETHODS: PayMethodsActionTypes = 'REMOVE_PAYMETHODS';

export const CURRENCY_FIELD_LABEL = 'Currency';

export class PaymentMethod {
  public static readonly CREDITCARD = 'CREDITCARD';
  public static readonly VOIDCHEQUE = 'VOIDCHEQUE';
  public static readonly CASH = 'CASH';
}

export class PaymentMethodLabel {
  public static readonly CREDITCARD = 'Credit Card';
  public static readonly VOIDCHEQUE = 'E.F.T.';
  public static readonly CASH = 'Cash';
}

export const CAD: Currency = 'CAD';
export const USD: Currency = 'USD';
export const currencyList: Currency[] = [CAD, USD];

export const DEFAULT_PAYER_ID = 0;

export const initialPayerDetail: PayerInfo = {
  id: DEFAULT_PAYER_ID,
  firstName: '',
  lastName: '',
  initial: '',
  address: '',
  city: '',
  country: 'CA',
  province: '',
  postalCode: '',
  mobile1: '',
  mobile2: '',
  email: '',
  payingMembers: []
};


// WEBPACK FOOTER //
// ./src/billing/billing.const.tsx